import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Global } from '@services/core/Global';
import { FormMode } from 'app/core/constants/form-mode';
import { DocumentUploadComponent } from '../document-upload/document-upload.component';

@Component({
  selector: 'app-party-document',
  standalone: true,
  imports: [CommonModule, FormsModule, DocumentUploadComponent],
  templateUrl: './party-document.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./party-document.component.css']
})
export class PartyDocumentComponent {
  documents = input.required<any>();
  mode = input(FormMode.EDIT);
  
  onDocumentUpdate = output<void>();
  onViewImage = output<string | number>();

  formMode = FormMode;
  globalUrl = Global.url;

  // Devuelve los documentos que corresponden al socio (no asociados a vehículo)
  getFilteredPartyDocs(): any[] {
    return this.documents()?.categories ?? [];
  }

  // Abre el visor en el padre (imágenes y PDF)
  openViewer(clickedId?: string | number) {
    if (clickedId) this.onViewImage.emit(clickedId);
  }
}
